export function hasTeamIconForLeague({ leagueId }: { leagueId: number }): boolean {
  return [
    LocalConstants.NRLW,
    LocalConstants.NRL,
    LocalConstants.StateOfOrigin,
    LocalConstants.StateOfOriginW,
    LocalConstants.AFLW,
    LocalConstants.AFL,
  ].includes(leagueId)
}

// ======
// Locals
// ======

const enum LocalConstants {
  // nrl
  NRL = 2000050687,
  NRLW = 2000117032,
  StateOfOrigin = 2000061880,
  StateOfOriginW = 2000115952,

  // afl
  AFL = 1000470474,
  AFLW = 2000097953,
}

// cspell:words AFLW NRLW
